import type { ReadyRosieVideo } from '@tadpoles/common'

export function requireReadyRosieVideoTitle(video: Readonly<ReadyRosieVideo>): string {
    if (video.title === undefined || video.title.length === 0) {
        throw new Error(`Library Video ${video.id} does not have a usable title.`)
    }

    return video.title
}
